import { createContext, useState } from "react";
import { authfetch, tryLogin, tryLogout } from "../pages/login/login_utils";
import { initializeUserTracking } from "../scripts/amplitude_utils";

const BackendContext = createContext({});

function loadLogin() {
  const lstr = localStorage.getItem("platlogin");
  try {
    return lstr ? JSON.parse(lstr) : {};
  } catch (error) {
    console.error("Error parsing JSON from localStorage:", error);
    return {};
  }
}

function saveLogin(lc) {
  localStorage.setItem("platlogin", JSON.stringify(lc));
}

export const BackendProvider = ({ children }) => {
  const [login, setLoginValue] = useState(() => {
    const restoredLogin = loadLogin();
    // Identify the restored user before any child effect fires its first event
    initializeUserTracking(restoredLogin);
    return restoredLogin;
  });
  const [termsRequired, setTermsRequired] = useState(null);

  const setLogin = (v) => {
    saveLogin(v);
    if (v.requires_terms_acceptance && v.terms_and_conditions) {
      setTermsRequired(v.terms_and_conditions);
    } else {
      setTermsRequired(null);
    }
    setLoginValue(v);
    initializeUserTracking(v);
  };

  const clearTermsRequired = () => {
    setTermsRequired(null);
  };

  return (
    <BackendContext.Provider
      value={{
        login: login,
        setLogin: setLogin,
        fetch: (url, args) => authfetch(url, args, login, setLogin),
        tryLogin: (username, password, keepLoggedIn) => tryLogin(username, password, keepLoggedIn, setLogin),
        tryLogout: () => tryLogout(setLogin),
        termsRequired: termsRequired,
        clearTermsRequired: clearTermsRequired,
      }}
    >
      {children}
    </BackendContext.Provider>
  );
};

export default BackendContext;
